module.exports = __webpack_public_path__ + "img/arrow-circle-broken-right.a805e4c3.svg";